import { Injectable } from '@angular/core';
import { ROUTES } from '../constants';
import { IAnneeAcademiqueResponse } from '../models/annee-academique.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnneeService {

  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get one year
   * @returns
   */
  get(id: number): Observable<IAnneeAcademiqueResponse> {
    return this.httpClient.get<IAnneeAcademiqueResponse>(`${ROUTES.annee.one}/${id}`);
  }
}
